<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Bin Card'"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
      </div>
      <div>
        <!-- <v-text-field
          v-model="search"
          label="Search Bin Card"
          append-icon="mdi-magnify"
          class="mb-4"
          clearable
        /> -->
        <DataTableWithPagination
          v-if="binCardData.length > 0"
          :headers="headers"
          :items="binCardData"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="onPageChange"
        >
          <template #row="{ item, index }">
            <tr
              :class="[
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td class="">{{ formatDate(item.created_at) }}</td>
              <td class="">{{ item.product_code }}</td>
              <td class="">{{ item.branch.name }}</td>
              <td class="">{{ item.stock_id }}</td>
              <td class="">{{ item.transaction_type }}</td>
              <td class="">{{ item.type }}</td>
              <td class="">{{ item.quantity }}</td>
            </tr>
          </template>
        </DataTableWithPagination>
        <v-alert v-else type="info" class="mt-5" outlined>
          No Bin Card records found.
        </v-alert>
      </div>
    </v-card>
  </div>
</template>

<script>
import { BinCardService } from "@/services/binCard-service.js";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch.vue";

export default {
  data() {
    return {
      headers: [
        { text: "Transaction Date", value: "created_at" },
        { text: "Product Code", value: "product_code" },
        { text: "Branch Name", value: "branch.name" },
        { text: "Stock ID", value: "stock_id" },
        { text: "Transaction Type", value: "transaction_type" },
        { text: "Type", value: "type" },
        { text: "Quantity", value: "quantity" },
      ],
      binCardData: [],
      loading: true,
      search: "",
      page: 1,
      total: 0,
    };
  },
  created() {
    this.fetchBinList();
  },
  components: {
    DataTableWithPagination,
    PageTitleWithSearch,
  },
  watch: {
    search() {
      this.page = 1;
      this.fetchBinList();
    },
    page() {
      this.fetchBinList();
    },
  },
  methods: {
    async fetchBinList() {
      this.loading = true;
      try {
        const response = await BinCardService.getBinCardReport(
          {
            search: this.search,
          },
          this.page,
        );
        this.binCardData = response.data?.data || [];
        this.total = response.data.meta.last_page || 0;
      } catch (error) {
        this.binCardData = [];
        this.total = 0;
        console.error("Error fetching Bin List:", error);
      } finally {
        this.loading = false;
      }
    },
    onPageChange(newPage) {
      this.page = newPage;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    searchChange(value) {
      this.search = value;
    },
  },
};
</script>
